import { calculateRange } from "utils/helpers";
import { ConditionalRenderer, CustomPagination } from "components";
import { CustomSelect } from "components/ui";
import { limitOptions } from "utils/constants";
import { useAppSelector } from "store/hooks";
import { userSettingState } from "store/selectors";

export function PaginatedFooter({
  totalPages,
  currentPage,
  handlePageChange,
  meta,
  limit,
  handleLimitChange,
}: any) {
  const { isDarkMode } = useAppSelector(userSettingState);
  return (
    <div className="flex justify-between items-center flex-wrap">
      <ConditionalRenderer condition={totalPages > 1}>
        <CustomPagination
          totalPages={totalPages}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />
      </ConditionalRenderer>

      <div className="flex items-center gap-4 my-3 sm:my-8 ml-auto">
        <div
          className={`flex gap-2 items-center ${
            isDarkMode ? "text-secondary" : "text-primary"
          }`}
        >
          Rows per page:
          <CustomSelect
            options={limitOptions}
            placeholder="25"
            onChange={handleLimitChange}
            value={limit}
            classes="w-20"
            showAbove
          />
        </div>
        <div className={isDarkMode ? "text-secondary" : "text-primary"}>
          {calculateRange(meta)}
        </div>
      </div>
    </div>
  );
}
